import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryComponent } from './tractors-history.component';
import {DxLoadPanelModule, DxScrollViewModule, DxTabsModule} from 'devextreme-angular';
import {TractorsHistoryToolbarModule} from '../tractors-history-toolbar/tractors-history-toolbar.module';
import {TractorsHistoryPopupModule} from '../tractors-history-popup/tractors-history-popup.module';
import {TractorsHistoryMapModule} from '../tractors-history-map/tractors-history-map.module';
import {TractorsHistoryMetricsModule} from '../tractors-history-metrics/tractors-history-metrics.module';
import {TractorsHistoryDetailsGridModule} from '../tractors-history-details-grid/tractors-history-details-grid.module';
import {TractorsHistoryGraphsModule} from '../tractors-history-graphs/tractors-history-graphs.module';
import {TractorsHistoryMessagesModule} from '../tractors-history-messages/tractors-history-messages.module';
import {TractorsHistoryFuelModule} from '../tractors-history-fuel/tractors-history-fuel.module';



@NgModule({
  declarations: [TractorsHistoryComponent],
  imports: [
    CommonModule,
    DxScrollViewModule,
    TractorsHistoryToolbarModule,
    TractorsHistoryPopupModule,
    DxTabsModule,
    TractorsHistoryMapModule,
    TractorsHistoryMetricsModule,
    TractorsHistoryDetailsGridModule,
    TractorsHistoryGraphsModule,
    TractorsHistoryMessagesModule,
    DxLoadPanelModule,
    TractorsHistoryFuelModule,
  ],
  exports: [TractorsHistoryComponent]
})
export class TractorsHistoryModule { }
